import { useState, useEffect } from 'react';
import { GOAL_STEPS, WEIGHT_UNIT } from '../../../types/enum';

const goalOptions = [
  { key: 'Lose weight', value: 'Lose weight' },
  { key: 'Maintain', value: 'Maintain' },
  { key: 'Gain weight', value: 'Gain weight' },
];

const EndGoal = ({ goals, setGoals, setCurrentStep, weightUnit }) => {
  const [weightOptions, setWeightOptions] = useState([]);

  useEffect(() => {
    setWeightOptions(
      Array.from(
        { length: weightUnit === WEIGHT_UNIT.LB ? 380 : 170 },
        (_, i) => i + (weightUnit === WEIGHT_UNIT.LB ? 60 : 30)
      )
    );
  }, [weightUnit]);

  const handleInput = (key) => () => {
    const endGoal = goalOptions.find((option) => option.key === key);
    if (endGoal?.value) {
      setGoals((prev) => ({ ...prev, endGoal: endGoal.value }));
    }
  };

  const handleNext = () => {
    try {
      setCurrentStep(GOAL_STEPS.DAILY_WORKOUT);
    } catch (err) {
      alert(err.message);
    }
  };

  const handleInputText = (e) => {
    setGoals((prev) => ({ ...prev, weight: e.target.value }));
  };

  return (
    <div>
      <h1 className='font-bold mb-3 text-white text-4xl'>
        What's your final goal?
      </h1>
      <div className='space-y-2'>
        {goalOptions.map((option) => (
          <div key={option.key}>
            <button
              className={`px-3 py-2 w-full rounded-full text-sm ${
                goals.endGoal === option.key
                  ? 'bg-yellow-500 text-black font-bold'
                  : 'bg-white text-black'
              }`}
              onClick={handleInput(option.key)}
            >
              {option.value}
            </button>
          </div>
        ))}
      </div>
      {(goals.endGoal === 'Lose weight' || goals.endGoal === 'Gain weight') && (
        <div className='mt-3'>
          <label className='text-white text-sm font-bold'>Goal weight</label>
          <div className='flex items-center gap-2'>
            <select
              className={`w-full bg-white rounded-full py-2 px-4  ${
                goals.weight && 'font-bold'
              }`}
              value={goals.weight}
              onChange={handleInputText}
            >
              <option
                value=''
                disabled
              >
                Select Weight
              </option>
              {weightOptions.map((option) => (
                <option
                  key={option}
                  value={option}
                >
                  {option}
                </option>
              ))}
            </select>
            <div className='text-white text-sm font-bold'>
              {weightUnit === WEIGHT_UNIT.LB ? 'lb' : 'kg'}
            </div>
          </div>
        </div>
      )}
      <button
        className={`w-full bg-yellow-500 text-black font-bold rounded-full hover:bg-yellow-600 transition-colors duration-200 py-3 mt-5 ${
          !goals.endGoal
            ? 'opacity-40'
            : 'hover:bg-yellow-600 transition-colors duration-200'
        }`}
        onClick={handleNext}
        disabled={!goals.endGoal}
      >
        Next
      </button>
    </div>
  );
};

export default EndGoal;
